export enum AutoInvestmentType {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
}
